/**
 * アプリ内 URL パス定数。
 * 文字列リテラルでのパス直書き禁止 — 必ずここから参照する。
 */

export const routes = {
  admin: {
    root: "/manage/admin",
    tenants: "/manage/admin/tenants",
    tenant: (id: string) => `/manage/admin/tenants/${id}`,
    users: "/manage/admin/users",
    superAdmins: "/manage/admin/super-admins",
    prompts: "/manage/admin/prompts",
    prompt: (promptId: string) => `/manage/admin/prompts/${promptId}`,
    llmSettings: "/manage/admin/llm-settings",
    systemSettings: "/manage/admin/system-settings",
    avatars: "/manage/admin/avatars",
    avatar: (avatarId: string) => `/manage/admin/avatars/${avatarId}`,
  },
  manage: {
    root: "/manage",
    usage: "/manage/usage",
    projects: "/manage/projects",
    projectNew: "/manage/projects/new",
    projectEdit: (projectId: string) => `/manage/projects/edit/${projectId}`,
    interviews: "/manage/interviews",
    interviewSession: (interviewId: string, sessionId: string) =>
      `/manage/interviews/${interviewId}/sessions/${sessionId}`,
    candidates: "/manage/candidates",
    screenings: "/manage/screenings",
    screening: (screeningId: string) => `/manage/screenings/${screeningId}`,
    organizations: "/manage/organizations",
    organization: (organizationId: string) =>
      `/manage/organizations/${organizationId}`,
    prompts: "/manage/prompts",
    prompt: (promptId: string) => `/manage/prompts/${promptId}`,
    settings: "/manage/settings",
  },
  auth: {
    signIn: "/login",
    forgotPassword: "/login/forgot-password",
    resetPassword: (email?: string) =>
      email
        ? `/login/reset-password?email=${encodeURIComponent(email)}`
        : "/login/reset-password",
  },
  participants: {
    root: "/manage/participants",
    detail: (participantId: string) => `/manage/participants/${participantId}`,
  },
  rooms: {
    root: "/manage/rooms",
    new: "/manage/rooms/new",
    detail: (roomId: string) => `/manage/rooms/${roomId}`,
    edit: (roomId: string) => `/manage/rooms/edit/${roomId}`,
    session: (roomId: string, sessionId: string) =>
      `/manage/rooms/${roomId}/sessions/${sessionId}`,
  },
  room: (shareUrlToken: string) => `/room/${shareUrlToken}`,
  sessionResult: (resultUrlToken: string) => `/session/${resultUrlToken}`,
  guide: "/manage/guide",
  apiDocs: "/manage/api-docs",
  docs: (lang: string) => `/docs/${lang}`,
  designSystem: "/design-system",
} as const;
